




import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SmallIcon',

  components: { FontAwesomeIcon },

  props: {
    icon: {
      // type: Object as PropType<string | Array<string>>,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'lg',
    },
  },
});
